module.exports = __webpack_public_path__ + "0d60c1d6a64d91dd8cb78439bdf6aaaa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-23.png
// module id = 2975
// module chunks = 0